import React from 'react';
import { Outlet } from 'react-router-dom';
import HashRedirect from '../redirects/HashRedirect';
import LocationChangeLogger from '../LocationChangeLogger';

/**
 * This layout logs all route (pathname) changes and handles any legacy hash-based (#/path) routes
 * that might come into the app via an old bookmark from a user.
 */
export default function LoggingAndRedirectLayout() {
  return (
    <HashRedirect>
      <LocationChangeLogger>
        <Outlet />
      </LocationChangeLogger>
    </HashRedirect>
  );
}
